import { render, staticRenderFns } from "./IdentifierList.vue?vue&type=template&id=ca025284"
import script from "./IdentifierList.vue?vue&type=script&lang=js"
export * from "./IdentifierList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports